import { useCallback, useState } from "react";

import { CommonKVNode } from "../../../types";
import {
  buildNodeDisplayMap,
  CollapseState,
  NodeDisplayMap,
  NodeFilters,
} from "./kvStoreNodes";

// Which nodes display under the current filters, plus the user's collapse
// overrides. The overrides reset whenever the data or the filters change.
const useNodeDisplayMap = (
  data: Record<string, CommonKVNode> | undefined,
  filters: NodeFilters
) => {
  const filterSignature = `${filters.keyFilter ?? ""}|${filters.valueFilter ?? ""}|${filters.agencyTagFilter.tags.join(",")}`;

  const [displayMap, setDisplayMap] = useState<NodeDisplayMap>(() =>
    buildNodeDisplayMap(data, filters)
  );
  const [prevFilterSignature, setPrevFilterSignature] =
    useState(filterSignature);
  const [prevData, setPrevData] = useState(data);

  if (prevFilterSignature !== filterSignature || prevData !== data) {
    setPrevFilterSignature(filterSignature);
    setPrevData(data);
    setDisplayMap(buildNodeDisplayMap(data, filters));
  }

  const setNodeCollapseState = useCallback(
    (node: CommonKVNode, state: CollapseState) => {
      setDisplayMap((prev) => {
        const entry = prev.get(node);
        if (!entry || entry.collapseState === state) {
          return prev;
        }
        const next = new Map(prev);
        next.set(node, { ...entry, collapseState: state });
        return next;
      });
    },
    []
  );

  return { displayMap, setNodeCollapseState };
};

export default useNodeDisplayMap;
